import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent implements OnInit {
  /**
   * Update version by web
   */
  constructor(@Inject(MAT_DIALOG_DATA) public data) {}

  ngOnInit() {
    this.data.message =
      this.data.message !== undefined
        ? this.data.message
        : '¿Está seguro de realizar la operación?';
    this.data.yes = this.data.yes !== undefined ? this.data.yes : 'ACEPTAR';
    this.data.no = this.data.no !== undefined ? this.data.no : 'CANCELAR';
  }
}
